/**
 * @generated SignedSource<<242fda12aba5fd2c3634acb6934381a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoredVideo_Subscription$variables = {
  id?: string | null | undefined;
};
export type StoredVideo_Subscription$data = {
  readonly videoUpdated: {
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"StoredVideo_Video">;
    } | null | undefined;
  };
};
export type StoredVideo_Subscription = {
  response: StoredVideo_Subscription$data;
  variables: StoredVideo_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "videoId",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoredVideo_Subscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoUpdatedPayload",
        "kind": "LinkedField",
        "name": "videoUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredVideo_Video"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoredVideo_Subscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VideoUpdatedPayload",
        "kind": "LinkedField",
        "name": "videoUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "optimizedUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "posterUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableSubtitles",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08a10e7959f2ef7b23b09df453ff7237",
    "id": null,
    "metadata": {},
    "name": "StoredVideo_Subscription",
    "operationKind": "subscription",
    "text": "subscription StoredVideo_Subscription(\n  $id: ID\n) {\n  videoUpdated(videoId: $id) {\n    video {\n      ...StoredVideo_Video\n      id\n    }\n  }\n}\n\nfragment StoredVideo_Video on Video {\n  id\n  optimizedUrl\n  posterUrl\n  status\n  ...Video_Video\n}\n\nfragment Video_Video on Video {\n  id\n  url\n  optimizedUrl\n  posterUrl\n  enableSubtitles\n}\n"
  }
};
})();

(node as any).hash = "37cdd8ea7e5322dffd6f9b4bc77e10dc";

export default node;
